import {
  Button,
  FormField,
  Input,
  SpaceBetween,
  TextContent,
  Box
} from "@cloudscape-design/components-themed";
import {
  CancelableEventHandler,
  ClickDetail,
} from "@cloudscape-design/components-themed/internal/events";
import { ChangeEvent, Dispatch, RefObject, SetStateAction } from "react";
import { useAsyncCallback } from "react-async-hook";
import { COMMON_LABELS } from "../../default-constants";


interface IFileUpload {
  inputRef: RefObject<HTMLInputElement>;
  label: string;
  name: string;
  placeholder: string;
  accept: string;
  multiple?: boolean;
  fileName: string;
  setUploadFile?: Dispatch<SetStateAction<File | undefined>>;
  setUploadFiles?: Dispatch<SetStateAction<File[] | undefined>>;
  errorText: string;
  setErrorText: Dispatch<SetStateAction<string>>;
  onChange: (event: ChangeEvent<HTMLInputElement>) => Promise<void>;
  onUpload: CancelableEventHandler<ClickDetail>;
  description?: string;
}

/**
 * ファイルアップロード
 */
export const FileUpload = (props: IFileUpload) => {
  const {
    inputRef,
    label,
    name,
    placeholder,
    accept,
    multiple,
    fileName,
    setUploadFile,
    setUploadFiles,
    errorText,
    setErrorText,
    onChange,
    onUpload,
    description
  } = props;
  const asyncEvent = useAsyncCallback(onChange);

  /**
   * クリアボタンを押したときに状態をリセットする.
   */
  const onClear = () => {
    if (setUploadFile) {
      setUploadFile(undefined);
    }
    if (setUploadFiles) {
      setUploadFiles(undefined);
    }
    setErrorText("");

    if (inputRef.current) {
      inputRef.current.value = "";
    }
  };

  return (
    <>
      <SpaceBetween direction={"horizontal"} size={"xs"}>
        <TextContent>
          <h5>{label}</h5>
        </TextContent>
        <FormField
          stretch={true}
          errorText={errorText}
          constraintText={
            "　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　"
          }
        >
          <SpaceBetween direction={"vertical"} size={"xs"}>
            <Input
              value={fileName}
              readOnly={true}
              placeholder={placeholder}
            ></Input>
            {description && (
              <Box color="text-status-error">
                  {description}
              </Box>
            )}
          </SpaceBetween>
        </FormField>
        <SpaceBetween direction={"horizontal"} size={"xxl"}>
          <Button variant={"normal"} onClick={onUpload}>
            {COMMON_LABELS.BTNS.REFERENCE}
          </Button>
          <Button variant={"normal"} onClick={onClear}>
            {COMMON_LABELS.BTNS.CLEAR}
          </Button>
        </SpaceBetween>
      </SpaceBetween>
      <input
        hidden
        ref={inputRef}
        name={name}
        type={"file"}
        accept={accept}
        onChange={asyncEvent.execute}
        multiple={multiple}
      />
    </>
  );
};
